// src/App.js
// @ts-nocheck
import React from "react";
import { Routes, Route } from "react-router-dom";

import OrionLanding from "./components/OrionLanding.jsx";
import CaseMasterPage from "./components/CaseMasterPage";
import LawyerAnywherePage from "./components/LawyerAnywherePage";
import ThemisPage from "./components/ThemisPage";
import IppokamposPage from "./components/IppokamposPage";
import PaceVibePage from "./components/PaceVibePage";
import InvoiceDemoPage from "./components/InvoiceDemoPage";
import InvoiceDocsPage from "./components/InvoiceDocsPage";
import ServicePage from "./components/ServicePage";
import CaseStudyPage from "./components/CaseStudyPage";
import { BlogIndexPage, BlogPostPage } from "./components/BlogPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PaceVibePrivacyPage from "./pages/PaceVibePrivacyPage";
import TermsPage from "./pages/TermsPage";
import NotFound from "./pages/NotFound.jsx";
import SuccessPage from "./pages/success.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<OrionLanding />} />
      <Route path="/casemaster" element={<CaseMasterPage />} />
      <Route path="/lawyer-anywhere" element={<LawyerAnywherePage />} />
      <Route path="/themis" element={<ThemisPage />} />
      <Route path="/ippokampos" element={<IppokamposPage />} />
      <Route path="/pacevibe" element={<PaceVibePage />} />
      <Route path="/pacevibe/privacy" element={<PaceVibePrivacyPage />} />
      <Route path="/invoice-demo" element={<InvoiceDemoPage />} />
      <Route path="/invoice-api" element={<InvoiceDocsPage />} />
      <Route path="/custom-software" element={<ServicePage slug="custom-software" />} />
      <Route path="/ai-automations" element={<ServicePage slug="ai-automations" />} />
      <Route path="/invoice-automation" element={<ServicePage slug="invoice-automation" />} />
      <Route path="/legal-tech" element={<ServicePage slug="legal-tech" />} />
      <Route path="/cloud-apps" element={<ServicePage slug="cloud-apps" />} />
      <Route path="/mobile-apps" element={<ServicePage slug="mobile-apps" />} />
      <Route path="/case-studies/casemaster-legal-tech" element={<CaseStudyPage slug="casemaster-legal-tech" />} />
      <Route path="/case-studies/invoice-intelligence" element={<CaseStudyPage slug="invoice-intelligence" />} />
      <Route path="/case-studies/ai-legal-workflow" element={<CaseStudyPage slug="ai-legal-workflow" />} />
      <Route path="/blog" element={<BlogIndexPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
